import api from "../services/api";

export const updateLanguageStatus = (data) => {
    return api.put('admin/language/update_status', data);
}

export const listLanguages = (queryParams) => {
    return api.get(`admin/language/list${queryParams}`);
};